/**
 * Reports Login Credential Model Interface
 * Framework-agnostic TypeScript interface
 */

export interface ReportsLoginCredential {
  id?: number;
  credential_id?: number;
  username: string;
  password?: string;
  region_id?: number;
  region_name?: string;
  state_id?: number;
  state_name?: string;
  city_id?: number;
  city_name?: string;
  role_id?: number;
  role_name?: string;
  access_level?: string;
  is_active?: number | boolean;
  created_at?: string;
  updated_at?: string;
  program_id?: number;
}

export interface ReportsLoginCredentialFormData {
  id?: number;
  credential_id?: number;
  username: string;
  password?: string;
  region_id?: number;
  state_id?: number;
  city_id?: number;
  role_id?: number;
  access_level?: string;
  is_active?: number | boolean;
}

export interface ReportsLoginCredentialApiResponse {
  data: {
    credentials: ReportsLoginCredential[];
  };
  message?: string;
  success?: boolean;
}
